import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import asyncComponent from '../../helpers/AsyncFunc';

const routes = [
  {
    path: '',
    component: asyncComponent(() => import('../dashboard')),
  },
  {
    path: 'settings',
    component: asyncComponent(() => import('../Page/settings')),
  },
  {
    path: 'companies',
    component: asyncComponent(() => import('../Page/companies')),
  },
  {
    path: 'products',
    component: asyncComponent(() => import('../Page/products')),
  },
  {
    path: 'product/:id',
    component: asyncComponent(() => import('../Page/product')),
  },
  {
    path: 'users',
    component: asyncComponent(() => import('../Page/users')),
  },
];

class AppRouter extends Component {
  render() {
    const { url, style } = this.props;
    return (
      <div style={style}>
        {routes.map(singleRoute => {
          const { path, exact, ...otherProps } = singleRoute;
          return (
            <Route
              exact={exact === false ? false : true}
              key={singleRoute.path}
              path={`${url}/${singleRoute.path}`}
              {...otherProps}
            />
          );
        })}
      </div>
    );
  }
}

export default AppRouter;
